import { mapState, mapGetters, mapActions } from 'vuex'
import { isEqual } from 'underscore'

export const SPBDefaultSelectionMixin = {
  computed: {
    ...mapState({
      selectedMethod: ({ smartForm }) => smartForm.selectedMethod
    }),
    ...mapGetters([
      'isSinglePaymentButton',
      'hasPreferredPaymentMethods',
      'effectivePreferredMethods',
      'effectivePaymentMethodList',
      'isActiveNestedAndCompactOrGridColumns'
    ])
  },
  created() {
    if (this.selectedMethod) return
    this.selectDefaultMethod()
  },
  methods: {
    ...mapActions(['selectMethod']),
    selectDefaultMethod() {
      if (!this.isSinglePaymentButton) return

      const defaultMethod = this.hasPreferredPaymentMethods
        ? this.effectivePreferredMethods[0]
        : this.effectivePaymentMethodList[0]

      this.selectMethod(defaultMethod)
    }
  },
  watch: {
    effectivePreferredMethods: {
      handler(newVal, oldVal) {
        /**
         * In compact/grid with 2+ columns layout, the active nested method is
         * removed from the PPM list, triggering this watcher unnecessarily.
         */
        if (
          !this.hasPreferredPaymentMethods ||
          this.isActiveNestedAndCompactOrGridColumns ||
          isEqual(newVal, oldVal)
        )
          return

        this.selectDefaultMethod()
      },
      deep: 1
    }
  }
}
